import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { MDBCard, MDBCardBody, MDBSpinner, MDBIcon } from "mdb-react-ui-kit";
import { confirmWaiverVerifyLink } from "../services/apiServices.js";
import SuccessScreen from "../components/sucessScreen.js";

/**
 * Landing route for email deep link: /waiver/verify/link?token=&pid=
 */
function WaiverVerifyLinkPage() {
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [result, setResult] = useState(null);

    useEffect(() => {
        const token = searchParams.get("token");
        const pid = searchParams.get("pid");
        if (!token || !pid) {
            setLoading(false);
            setError("Invalid verification link.");
            return;
        }
        let cancelled = false;
        (async () => {
            try {
                const res = await confirmWaiverVerifyLink(token, pid);
                if (!res || res === "false") {
                    if (!cancelled) {
                        setError("Verification request failed.");
                    }
                    return;
                }
                const data = await res.json();
                if (!cancelled) {
                    if (data.status) {
                        setResult(data);
                    } else {
                        setError(data.message || "Verification failed.");
                    }
                }
            } catch (e) {
                if (!cancelled) setError("Something went wrong. Please try again.");
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [searchParams]);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center py-5">
                <MDBSpinner />
                <span className="ms-2">Verifying your email…</span>
            </div>
        );
    }

    if (error) {
        return (
            <MDBCard className="m-4">
                <MDBCardBody className="text-center py-5">
                    <MDBIcon fas icon="exclamation-circle" className="text-danger fa-3x mb-3" />
                    <h5>Could not verify</h5>
                    <p className="text-muted">{error}</p>
                </MDBCardBody>
            </MDBCard>
        );
    }

    if (result) {
        const pdf =
            result.pdfFileLink ||
            (Array.isArray(result.pdfFileLinks) && result.pdfFileLinks[0]) ||
            "";
        return (
            <div className="py-3">
                <SuccessScreen pdfFileLink={pdf} />
            </div>
        );
    }

    return null;
}

export default WaiverVerifyLinkPage;
